export default __webpack_public_path__ + "static/media/murdoch4.7b0df488.png";